import * as React from "react";
import Content from "../../../Content";
import Axios from "../../Components/Axios";
import {Link} from "react-router-dom";
import "../../../DataTable/Table.scss";

class Activator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            login: props.login,
            status: props.status
        };
    }

    changeStatus(status) {
        Axios
            .post('api/services/set_status', {
                status: status,
                login: this.state.login
            })
            .then(r => this.setState({ status: r.data.status }))
            .catch(() => this.props.history.push('/'));
    }

    render() {
        if(this.state.status) {
            return (
                <div className="btn-group">
                    <button className="btn btn-success">Активный</button>
                    <button className="btn btn-outline-danger" onClick={()=>this.changeStatus(false)}>Деактивировать</button>
                </div>
            );
        }

        return (
            <div className="btn-group">
                <button className="btn btn-outline-success" onClick={()=>this.changeStatus(true)}>Активировать</button>
                <button className="btn btn-danger">Деактивировано</button>
            </div>
        );
    }
}

class ServicesEdit extends React.Component {

    th() {
        return <tr>
            <th>ID</th>
            <th>Логин</th>
            <th>Услуга</th>
            <th>Статус</th>
            <th>Действие</th>
        </tr>;
    }

    header() {
        return <thead>{ this.th() }</thead>;
    }

    footer() {
        return <tfoot>{ this.th() }</tfoot>;
    }

    constructor(props) {
        super(props);
        this.state = {};
        this.state.data = [];
    }

    componentDidMount() {
        Axios
            .get('api/services/list')
            .then(r => this.setState({ data: r.data }))
            .catch(() => this.props.history.push('/'));
    }

    render() {
        return (
            <Content title = "Управление услугами">

                <div className="row mb-3">
                    <div className="col d-flex justify-content-between align-items-center">
                        <h5>Управление услугами</h5>
                        <Link className="btn btn-success float-right" to={'services_edit/add'}>+ Добавить</Link>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                        { this.header() }
                        { this.footer() }
                        <tbody>
                        {
                            this.state.data.map(e => (
                                <tr key={e.id}>
                                    <td>{e.id}</td>
                                    <td>{e.login}</td>
                                    <td>{e.titleRu}</td>
                                    <td>
                                        <Activator login = {e.login} status = {e.status} />
                                    </td>
                                    <td>
                                        <Link className="btn btn-info" to={`/admin/services_edit/edit/${e.login}`}>Редактировать</Link>
                                        <a className="btn btn-info ml-3" href = {`/${e.login}`} target="_blank" rel="noreferrer">Перейти на страницу подключения</a>
                                    </td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>

            </Content>
        );
    }
}

export default ServicesEdit;